import * as XLSX from 'xlsx'
import store from '../../store/store';
import { showMessageOnFailure } from '../../store/error.actions';

const jsonToExcel = (data: any, fileName: string, columnNames: Array<any>, multiSheet: boolean = false) => {

    let newFileName = ''

    fileName.length > 20 ? newFileName = fileName.slice(0,15) : newFileName = fileName

    try {
        const workbook = XLSX.utils.book_new()
        
        if (!multiSheet) {            
            let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
            XLSX.utils.sheet_add_aoa(worksheet, columnNames)
            worksheet['!cols'] = [{wch: 5}, {wch: 30}, {wch: 30}, {wch: 15}, {wch: 15}, {wch: 15}];
            const sheet: XLSX.WorkSheet = XLSX.utils.sheet_add_json(worksheet, data, { origin: 'A2', skipHeader: true })
            XLSX.utils.book_append_sheet(workbook, sheet,`${newFileName}.xlsx`)
            XLSX.writeFile(workbook, `${newFileName}.xlsx`, { type: 'file' })
        }
        
        if (multiSheet) {
            const Keys = Object.keys(data)

            if (Keys.length === 0) {
                store.dispatch(showMessageOnFailure('No records availble at the moment!!!'))
            }

            Keys.forEach((key) => {
                let ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
                XLSX.utils.sheet_add_aoa(ws, columnNames)
                ws['!cols'] = [{wch: 10}, {wch: 40}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}];
                const sheet: XLSX.WorkSheet = XLSX.utils.sheet_add_json(ws, data[key], { origin: 'A2', skipHeader: true })
                XLSX.utils.book_append_sheet(workbook, sheet, key);
            })
            XLSX.writeFile(workbook, `${newFileName}.xlsx`, { type: 'file' })
        }

        return true
    } catch (error) {
        console.log(error)
        return false
    }
}

export default jsonToExcel